
<button class="btn btn-primary" (click)="captureScreen()"> שלח </button>
<!-- 
<div id="contentToConvert">

</div> -->
